/** Simple data helper to parse the userprofile data from the query and expose independent fields.
  * This is used to avoid having to parse the query data in multiple places. Should match the userprofile query contract
  * Designed not to store any data intentionally to avoid stale data issues esp with Apollo Cache
  
  * @param {object} data - the data returned from the userprofile query
  * @param {boolean} userThumbnailsEnabled - whether to use userThumbnails field instead of thumbnails
  * @returns {object} - an object with the fields exposed
  * @example
  * const { firstName, lastName, avatar } = DataHelper(data, userThumbnailsEnabled)
  
*/
// TODO: Consider this function helper to be a hook instead.
function DataHelper(data, userThumbnailsEnabled = false) {
  const { personalInfo, profileImages } = data?.userProfile;
  const { aboutMe, professionalInfo, basicInfo, webLinks, contactInfo } = personalInfo;

  // Use userThumbnails if flag is enabled, otherwise use thumbnails
  const selectedThumbnails = userThumbnailsEnabled ? profileImages?.userThumbnails : profileImages?.thumbnails;

  return {
    personalInfo,
    profileImages,
    firstName: basicInfo?.firstName,
    lastName: basicInfo?.lastName,
    avatar: selectedThumbnails?.sizeX120,
    aboutMe: aboutMe,
    primaryEmail: personalInfo?.primaryEmail,
    countryCode: personalInfo?.countryCode,
    language: personalInfo?.language,
    isLdapEnabled: personalInfo?.ldapInfo?.isLdapEnabled,
    industry: professionalInfo?.industry,
    industryTaxonomyIds:
      professionalInfo?.additionalProfessionalInfo?.industryTaxonomyIds ?? [],
    industryCode: professionalInfo?.industryCode,
    jobTitle: professionalInfo?.jobTitle,
    roleId: professionalInfo?.additionalProfessionalInfo?.roleId,
    roleName: data?.roleName,
    companyName: professionalInfo?.company?.companyName,
    address: contactInfo?.address,
    phones: contactInfo?.phones,
    alternateEmail: contactInfo?.alternateEmail,
    blog: webLinks?.blog,
    linkedInProfile: webLinks?.linkedInProfile,
    website: webLinks?.website,
  };
}

export default DataHelper;
